module.exports = __webpack_public_path__ + "img/fi-rr-tool-marquee.4192babb.svg";